/*
 * (c) Copyright, 2024, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { useServiceContext } from '../../../../root'
import { TableHeadRow, TableRow, TableHeadCell } from '../../../../components/table/TableComponents'
import { RcmTable } from '../../../../components/rcm-table/RcmTable'
import TableMenu from './TableMenu'

interface OverviewTableProps {
  showMilestone?: boolean
  [key: string]: any
}

const OverviewTable: React.FC<OverviewTableProps> = (propsParent) => {
  const context = useServiceContext()
  const { translate } = context.service.filter

  return (
    <div className="theme-sandman">
      <RcmTable
        className="workflow-list-table chita-table"
        noResultsText="NO_RESULTS_FILTERED"
        HeadRow={
          <TableHeadRow className="has-actions overview-table-header">
            <TableHeadCell>{translate('EMTF_MD_TRIAL')}</TableHeadCell>
            <TableHeadCell>{translate('EMTF_MD_ENVIRONMENT')}</TableHeadCell>
            <TableHeadCell>{translate('EMTF_MD_COUNTRY')}</TableHeadCell>
            <TableHeadCell>{translate('EMTF_MD_SITE')}</TableHeadCell>
            <TableHeadCell>{translate('EMTF_ZONE')}</TableHeadCell>
            <TableHeadCell>{translate('EMTF_SECTION')}</TableHeadCell>
            {propsParent?.showMilestone && <TableHeadCell>{translate('ETMF_OVERVIEW_MILESTONE')}</TableHeadCell>}
            <TableHeadCell>{translate('DOCUMENT_NAME')}</TableHeadCell>
            <TableHeadCell className="actions">{translate('ACTIONS')}</TableHeadCell>
          </TableHeadRow>
        }
        Row={(props: any) => {
          const row = props.row
          return (
            <TableRow {...props}>
              <td className="clipped-cell">{row?.trial ? row.trial : translate('NOT_AVAILABLE')}</td>
              <td className="clipped-cell">{row?.environment ? row.environment : translate('NOT_AVAILABLE')}</td>
              <td className="clipped-cell">{row?.country ? row.country : translate('NOT_AVAILABLE')}</td>
              <td className="clipped-cell">{row?.site ? row.site : translate('NOT_AVAILABLE')}</td>
              <td className="clipped-cell">{row?.zone ? row.zone : translate('NOT_AVAILABLE')}</td>
              <td className="clipped-cell">{row?.section ? row.section : translate('NOT_AVAILABLE')}</td>
              {propsParent?.showMilestone && (
                <td className="clipped-cell">{row?.milestone ? row.milestone : translate('NOT_AVAILABLE')}</td>
              )}
              <td className="clipped-cell">
                {row?.name
                  ? row.name.length > 80
                    ? row.name.substring(0, 80) + '...'
                    : row.name
                  : translate('NOT_AVAILABLE')}
              </td>
              <td className="actions">
                <TableMenu item={row} />
              </td>
            </TableRow>
          )
        }}
        {...propsParent}
      />
    </div>
  )
}

export default OverviewTable
